import React, { ReactNode } from "react";
import {
  CancellationReason,
  FormattedPlanDetails,
  FormattedPlanDetailsMapping,
  PromoCodePlansPricesType,
} from "@shared/types";
import { CancellationStep } from "@shared/features/settings/subscription/types";

export const CancelSubscriptionContext = React.createContext<
  | {
      step: CancellationStep;
      setStep: (step: CancellationStep) => void;
      onNextClick: () => void;
      isLoadingCancelSubscription: boolean;
      reason: CancellationReason | undefined;
      setReason: (reason?: CancellationReason) => void;
      otherReasonDescription: string;
      setOtherReasonDescription: (otherReasonDescription: string) => void;
      isInvalidReasonDescription?: boolean;
      plans?: FormattedPlanDetailsMapping;
      promoCodePrices: PromoCodePlansPricesType | undefined;
      currentDiscount?: number;
      isLoading?: boolean;
      onBackButtonClick?: () => void;
      plan: FormattedPlanDetails | undefined;
      discount: number;
      getBackButton: () => ReactNode;
    }
  | undefined
>(undefined);
